import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { enqueueSnackbar } from "../../../components/GlobalSnackbar/snackbarStore";
import { useSpace } from "../../../hooks/useSpace";
import { keys } from "./keys";

async function deleteProvider(providerId: string) {
  const { error } = await apiClient
    .from('providers')
    .delete()
    .eq('id', providerId);

  if (error) {
    throw error;
  }
}

export default function useDeleteProvider() {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();

  return useMutation({
    mutationFn: (providerId: string) => deleteProvider(providerId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.getProvidersList(currentSpace!.id) });
      enqueueSnackbar('Prestataire supprimé.', 'success');
    }
  });
}
